import Image from "components/Image"
import Link from "next/link"
import { getExcerpt } from "utilities/getExcerpt"
import storyblokImageLoader from "utilities/storyblokImageLoader"

export default function BlogCard({ content, full_slug }) {
  return (
    <div className="border-0.5 border-grey-cool bg-white">
      <Link href={full_slug} replace>
        <Image
          loader={
            content.featured_image?.filename && content.featured_image?.filename !== ""
              ? storyblokImageLoader
              : undefined
          }
          src={
            content.featured_image?.filename && content.featured_image?.filename !== ""
              ? content.featured_image.filename
              : "/assets/placeholder.png"
          }
          alt={content.featured_image?.alt ? content.featured_image.alt : content.title}
          placeholder={content.featured_image?.blurDataURL ? "blur" : "empty"}
          blurDataURL={content.featured_image?.blurDataURL}
          width={299}
          height={153}
          className="w-full aspect-[2/1] object-cover"
          sizes="(max-width: 1024px) 45vw, (max-width: 640px) 95vw, 20vw"
        />
      </Link>
      <div className="py-7 px-4 xl:px-7">
        <Link className="bracket-link block w-full mr-8" href={full_slug} replace>
          <h2 className="text-m1 font-semibold text-primary text-center">{content.title}</h2>
        </Link>
        <p className="pt-4">{content.excerpt || getExcerpt(content.content, 200)}</p>
      </div>
    </div>
  )
}
